"use strict";

exports.__esModule = true;
exports.TICKET_STATUS_OPEN = exports.TICKET_STATUS_IN_PROGRESS = exports.TICKET_STATUS_CLOSED = exports.LOGBOOK_TICKET = exports.LOGBOOK_COMMENT = exports.INTERNAL_USER = exports.EVENTS = exports.ALERT = void 0;
var LOGBOOK_COMMENT = exports.LOGBOOK_COMMENT = "Comment";
var LOGBOOK_TICKET = exports.LOGBOOK_TICKET = "Ticket";
var ALERT = exports.ALERT = "Alert";
var EVENTS = exports.EVENTS = [LOGBOOK_TICKET, LOGBOOK_COMMENT];
var INTERNAL_USER = exports.INTERNAL_USER = "Internal User";
var TICKET_STATUS_OPEN = exports.TICKET_STATUS_OPEN = "OPEN";
var TICKET_STATUS_IN_PROGRESS = exports.TICKET_STATUS_IN_PROGRESS = "IN_PROGRESS";
var TICKET_STATUS_CLOSED = exports.TICKET_STATUS_CLOSED = "CLOSED";